import defaultAttributes from "./defaultAttributes";
import codeTemplate from "./codeTemplate";
import presets from "./presets";

let CalendarDefinitions = { defaultAttributes, codeTemplate, presets };

export default CalendarDefinitions;
